<script>
import GlobalVue from '@root/helper/Global.vue';

export default {
  name: "NavBar",
  extends: GlobalVue,
  mounted(){
    window.nav = this
  },
  methods:{
    logout(){
      swal({
        title: "Are you sure you want to exit the app?",
        text:"",
        icon: "warning",
        buttons: ["No, Cancel!", "Yes, Sure!"],
        // dangerMode: true,
      }).then(ok => {
        if(!ok) return

        this.page.logout()

        setTimeout(() => {         
          swal({
            title: "Logout Successfull",
            text:"",
            icon: "success",          
            // dangerMode: true,
          })
         }, 100)
      })
    }
  }
}
</script>

<template>
  <header class="topbar">
    <nav class="navbar top-navbar navbar-expand-md navbar-dark">
      <!-- ============================================================== -->
      <!-- Logo -->
      <!-- ============================================================== -->
      <div class="navbar-header">
        <router-link :to="{name:'Dashboard'}" class="navbar-brand">
          <div class="logo_img">
            <img :src="assets('images','bayer-logo.svg')" alt="homepage" />
          </div>
          <span class="ml-0">
            <img :src="assets('images','logo-text.png')" class="w-auto" alt="Bayer Employee Facility System">
          </span>
        </router-link>
      </div>
      <!-- ============================================================== -->
      <!-- End Logo -->
      <!-- ============================================================== -->
      <div class="navbar-collapse">
        <!-- ============================================================== -->
        <!-- toggle and nav items -->
        <!-- ============================================================== -->
        <ul class="navbar-nav mr-auto">
          <!-- This is  -->
          <li class="nav-item">
            <a class="nav-link nav-toggler d-block d-md-none waves-effect waves-dark" href="javascript:void(0)">
              <i class="ti-menu"></i>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link sidebartoggler d-none waves-effect waves-dark" href="javascript:void(0)">
              <i class="icon-menu"></i>
            </a>
          </li>
        </ul>
        <!-- ============================================================== -->
        <!-- User profile and search -->
        <!-- ============================================================== -->
        <ul class="navbar-nav my-lg-0">
          <!-- ============================================================== -->
          <!-- User Profile -->
          <!-- ============================================================== -->
          <li class="nav-item dropdown u-pro">
            <a class="nav-link dropdown-toggle waves-effect waves-dark profile-pic" href="" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              <span class="hidden-md-down">{{user.employeename}} ({{user.al_name}}) <i class="fa fa-angle-down"></i></span>
            </a>
            <div class="dropdown-menu dropdown-menu-right">
              <!-- <a href="javascript:void(0)" class="dropdown-item"><i class="ti-user"></i> My Profile</a>
              <a href="javascript:void(0)" class="dropdown-item"><i class="ti-email"></i> Inbox</a>
              <div class="dropdown-divider"></div>
              <a href="javascript:void(0)" class="dropdown-item"><i class="ti-settings"></i> Account Setting</a> -->
              <router-link :to="{name: 'Profile'}" class="dropdown-item"><i class="fa fa-user"></i> Profile</router-link>
              <a href="javascript:;" @click="logout()" class="dropdown-item"><i class="fa fa-power-off"></i> Logout</a>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>
